export const Work = [
    {
        id:1,
        name:"Elecar Landing Page",
        description:"Responsive site",
        tags:["js","css","html"],
        
        demo:"https://mysikm.github.io/-Elecar/",
        github:"https://github.com/MysikM/-Elecar"
    },
    {
        id:2,
        name:"Coffee shop",
        description:"FRESH COFFEE IN THE MORNING",
        tags:["js","css","html"],

        demo:"https://mysikm.github.io/coffee-shop/",
        github:"https://github.com/MysikM/coffee-shop"
        
    },
    {
        id:3,
        name:"Tetris game",
        description:"game build on clean js.",
        tags:["vanilaJS","css","html"],

        demo:"https://mysikm.github.io/Basic-Tetris/",
        github:"https://github.com/MysikM/Basic-Tetris"

    },
    {
        id:4,
        name:"deliciousss",
        description:"deliciousss site with using ReactJS. With realtime fetching of articles from dev.to using API.",
        tags:["react","api","sass"],

        demo:"https://mysikm.github.io/deliciousss/",
        github:"https://github.com/MysikM/deliciousss"
    },
    {
        id:5,
        name:"Sidebar Menu",
        description:"A cool looking sidebar menu build using js and css.",
        tags:["js","css","html"],

        demo:"https://mysikm.github.io/miami-slider/",
        github:"https://github.com/MysikM/miami-slider"
       
    },
    {
        id:6,
        name:"Device Landing",
        description:"Site build using html and css",
        tags:["js","css","html"],

        demo:"https://mysikm.github.io/Device/",
        github:"https://github.com/MysikM/Device"
        
    },
  
] 